import { useCallback } from 'react';
import { useUpdateActivityButtons } from './useUpdateActivityButtons';
export const useHandleUpdateActivityButtons = ({
  updateQuery
}) => {
  const updateActivityButtons = useUpdateActivityButtons({
    updateQuery
  });
  const handleUpdateActivityButtons = useCallback(selectedActivityButtons => {
    updateActivityButtons(selectedActivityButtons);
  }, [updateActivityButtons]);
  return {
    handleUpdateActivityButtons
  };
};